<proffeo-ui-dialog [title]="title">
  <p
    [innerHTML]="desc"
    class="text-base"
  ></p>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      (clicked)="close(false)"
      variant="primary"
      text="modals.confirmation-modal-cancel"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="close(true)"
      variant="accent"
      text="modals.confirmation-modal-confirm"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
